import {Component, Input, ViewEncapsulation} from '@angular/core';
import { ItemCounterComponent } from '@spartacus/storefront';
import { UigActiveCartService } from 'src/app/services/uig-active-cart.service';
import {MultiCartService} from "@spartacus/cart/base/core";

@Component({
    selector: 'app-uig-item-counter',
    templateUrl: './uig-item-counter.component.html',
    styleUrls: ['./uig-item-counter.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigItemCounterComponent extends ItemCounterComponent {
  @Input() entryNumber: number;
  @Input() cartId?: string;
  @Input() savedCarts? : boolean;
  @Input() userId? : string;

  constructor(
    private uigCartService: UigActiveCartService,
    private multiCartService: MultiCartService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  valueChange($event) {
    this.updateEntry($event.target.value);
  }

  increment() {
    this.updateEntry(this.control.value + this.step);
  }

  decrement() {
    this.updateEntry(this.control.value - this.step);
  }

  private updateEntry(value: number) {
    if(this.savedCarts == true && this.userId) {
      this.multiCartService.updateEntry(this.userId,this.cartId, this.entryNumber,value);
    }
    else {
      this.uigCartService
      .updateEntry(this.entryNumber, value)
      .subscribe((entries) => {
        if (entries instanceof Array) {
          entries.forEach((entry) => {
            if (entry.entryNumber === this.entryNumber) {
              this.setControlValue(entry);
            }
          });
        } else {
          if (entries.entryNumber === this.entryNumber) {
            this.setControlValue(entries);
          }
        }
      });
    }
  }

  private setControlValue(entry) {
    this.control.setValue(entry.quantity, { emitEvent: false });
    this.control.markAsPristine();
  }
}
